const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("tokenn");

  if (!token) {
    window.location.href = process.env.REACT_APP_MAT_URL;
    localStorage.clear();
  }
  return children
}
export default ProtectedRoute;
